// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"b51b5923a446305ae914","258":"b8e02c6d42e1c51fb512"}[chunkId] + ".js";
};